import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Client-side navigation keeps the scroll position by default, which lands you
// halfway down a page you have never seen. Reset on every path change, but not
// when only the hash changes, so in-page anchors still work.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
